const Modifiers = (props) => {
  const { item } = props;
  const { modifiers } = item;

  if (!modifiers) return null;

  let modifierString = '';

  const { options } = modifiers;

  if (options) {
    Object.keys(options).forEach((slug) => {
      options[slug].forEach((modifier) => {
        if (modifier.prefix) {
          modifierString += `${modifier.prefix} `;
        }
        modifierString += modifier.title;
        modifierString += ', ';
      });
    });
  }

  const modifierStringTrimmed = modifierString.slice(0, -2);

  return (
    <div className="c7-cart-items__title__description">
      {modifierStringTrimmed}
    </div>
  );
};

export default Modifiers;
